import React from "react";
import { Route, Redirect } from "react-router-dom";

const PSMGuard = ({ children, ...rest }) => {
    const token = localStorage.getItem("kloka:token:data");
    const type = localStorage.getItem("kloka:type");
    const categories = localStorage.getItem("kloka:categories");
    
    const isPSM = categories
        ? categories && categories.includes("HR")
        : false;

    return (
        <Route
            {...rest}
            render={({ location }) =>
                (token && (type === "inhouse") && isPSM) ? (
                    children
                ) : (
                    <Redirect
                        to={{
                        pathname: "/",
                        state: { from: location },
                        }}
                    />
                )
            }
        />
    );
};

export default PSMGuard;
